export const removeToolData = [
	{
		icon: '✅',
		title: 'removeToolData_title1',
		subtitle: 'removeToolData_subtitle1',
	},
	{
		icon: '✅',
		title: 'removeToolData_title2',
		subtitle: 'removeToolData_subtitle2',
	},
	{
		icon: '✅',
		title: 'removeToolData_title3',
		subtitle: 'removeToolData_subtitle3',
	},
	{
		icon: '✅',
		title: 'removeToolData_title4',
		subtitle: 'removeToolData_subtitle4',
	},
];
